/* eslint-disable */
import { isEmpty } from 'lodash';
import tmsApi from '../api/tmsApi';
import helper from './helper';

const { createInputParam, stringify } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      vehicle: 'LOADING',
    },
    vehicles: [],
    detailData: null,
    detailDataId: null,
    dataLoaded: false,
    count_info: {
      all: 0,
    },
    query: {
      search: '',
      company_id: null,
      page: {
        number: 1,
        count: 10,
      },
      sort: {
        by: 'CREATED_AT',
        direction: 'ASC',
      },
    },
    errors: {
      actions: [],
    },
    vehicle_driver: null,
    vehicle_driver2: null,
  },
  mutations: {
    CLEAR_DATA(state) {
      state.vehicles.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.vehicles.push(data);
    },
    REPLACE_DATA(state, vehicles) {
      state.vehicles.splice(0, state.vehicles.length, ...vehicles);
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.company_id = null;
      query.page.number = 1;
      query.page.count = 10;
      query.sort.by = 'CREATED_AT';
      query.sort.direction = 'ASC';
    },
    SET_COMPANY_ID(state, id) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.company_id = id;
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
      }, this);
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.vehicles.findIndex(vehicle => vehicle.id === id);
      state.vehicles.splice(index, 1);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    SET_DATA_VEHICLE({ dataState }, state) {
      dataState.vehicle = state;
    },
    SET_VEHICLE_DRIVER(state, data) {
      state.vehicle_driver = data;
    },
    SET_VEHICLE_DRIVER2(state, data) {
      state.vehicle_driver2 = data;
    },
    CLEAR_DATA_VEHICLE_DRIVER(state) {
      state.vehicle_driver = null;
    },
    CLEAR_DATA_VEHICLE_DRIVER2(state) {
      state.vehicle_driver2 = null;
    },
  },
  getters: {
    vehicles(state) {
      return state.vehicles;
    },
    companies(state) {
      return state.vehicles;
    },
    count_all(state) {
      return state.count_info.all;
    },
    query_count(state) {
      return state.query.page.count;
    },
    query_page(state) {
      return state.query.page.number;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    loadVehicle(state) {
      return state.dataState.vehicle;
    },
    get_vehicle_driver(state) {
      return state.vehicle_driver || {};
    },
    get_vehicle_driver2(state) {
      return state.vehicle_driver2 || {};
    }
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      let searchQuery = '';
      if (typeof state.query.search === 'string' && state.query.search.trim().length) {
        const q = state.query.search.trim();
        searchQuery = `query: "${q}"`;
      }
      const query = `
        {
          vehicles(
            offset: ${offset},
            limit: ${limit},
            ${searchQuery}
            sort: {
                by: ${by},
                direction: ${direction}
            },
            ${companyId}
          ) {
            id
            reg_no
            company {
              id
              name
            }
            gps_devices {
              id
              number
              type
              gps_info {
                longitude
                latitude
              }
              metadata
              created_at
            }
            created_at
            driver {
              id
              name
            }
            groups {
              id
              name
              description
            }
          }
        }
      `;
      // commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_VEHICLE', 'LOADING');
      return api(query, 'vehicles').then(({ data }) => {
        const { vehicles } = data;
        commit('REPLACE_DATA', vehicles);
        commit('SET_DATA_LOADED');
        commit('SET_DATA_VEHICLE', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_VEHICLE', 'ERROR');
      });
    },
    LOAD_INFO({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const companyId = createInputParam(state.query, 'company_id', false);
      const query = `
        {
          vehicle_info(
            query: "${state.query.search}"
            ${companyId}
          ) {
              count
          }
        }
      `;
      // commit('CLEAR_DATA');
      return api(query, 'vehicle_info').then(({ data }) => {
        const { vehicle_info } = data;
        commit('SET_COUNT_INFO', vehicle_info);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_INFO');
      });
    },
    LOAD_ASSIGNED_VEHICLE({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          my_info {
            assigned_vehicle {
              id
              reg_no
              company {
                id
                name
              }
              gps_devices {
                id
                number
                type
                gps_info {
                  longitude
                  latitude
                }
                metadata
                created_at
              }
              created_at
              driver {
                id
              }
            }
          }
        }
      `;
      return api(query, 'my_info').then(({ data }) => {
        const { vehicle_info: { assigned_vehicle } } = data;
        commit('REPLACE_DATA', assigned_vehicle);
        commit('SET_DATA_LOADED');
        commit('SET_DATA_VEHICLE', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_VEHICLE', 'ERROR');
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const query = `
        {
          vehicles: find_vehicles(
            query: "${state.query.search}",
            offset: ${offset},
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${companyId}
          ) {
            id
            reg_no
            gps_devices {
              id
              number
              type
              gps_info {
                longitude
                latitude
              }
              metadata
              created_at
            }
            company {
              id
              name
            }
            created_at
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      return api(query, 'find_vehicles').then(({ data }) => {
        const { vehicles } = data;
        vehicles.forEach((vehicle) => {
          commit('ADD_DATA_ON_LIST', vehicle);
        }, this);
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('ADD_ERROR', 'FIND_DATA');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          vehicle(id: ${state.detailDataId}) {
            id
            reg_no
            container {
              type
              length
              width
              height
            }
            driver {
              id
              name
            }
            gps_devices {
              id
              number
              type
              gps_info {
                longitude
                latitude
              }
              metadata
              created_at
            }
            company {
              id
              name
              type
            }
            user {
              id
              username
              full_name
              email
              created_at
            }
            prestart_checklist {
              id
              question
            }
            metadata
            created_at
          }
        }
      `;
      commit('SET_DATA_NOT_LOADED');
      return api(query, 'vehicle').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.vehicle);
        return data.vehicle;
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    UPDATE_DATA({ state, commit, rootState }, payloads) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const regNo = createInputParam(payloads, 'reg_no');

      const mtdt = payloads.metadata;
      let metadata = '';
      if (!isEmpty(mtdt)) {
        const storageType = createInputParam(mtdt, 'storage_type');
        const workingArea = stringify(payloads.metadata.working_area);
        const fleetEquipment = stringify(payloads.metadata.fleet_equipment);
        const document = stringify(payloads.metadata.document);
        const cdd = payloads.metadata.cdd;
        const standby = payloads.metadata.standby;
        metadata = `metadata: {
          ${storageType}
          working_area: ${workingArea}
          fleet_equipment: ${fleetEquipment}
          document: ${document}
          cdd: ${cdd}
          standby: ${standby}
        }`;
      }

      const cont = payloads.container;
      let container = '';
      if (!isEmpty(cont)) {
        const type = createInputParam(cont, 'type', false);
        const width = createInputParam(cont, 'width', false);
        const length = createInputParam(cont, 'length', false);
        const height = createInputParam(cont, 'height', false);
        container = `container: {
          ${type}
          ${width}
          ${length}
          ${height}
        }`;
      }

      const mutation = `mutation {
        vehicle: update_vehicle(id: ${detailDataId}, input: {
          ${regNo}
          ${container}
          ${metadata}
        }) {
          id
          reg_no
          container {
            type
            length
            width
            height
          }
          metadata
          updated_at
        }
      }`;

      return api(mutation, 'update_vehicle').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.vehicle);
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    CREATE_DATA({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const regNo = createInputParam(payloads, 'reg_no');
      const comp = payloads.company;
      const cont = payloads.container;
      const companyId = comp.id;
      let container = '';
      const mtdt = payloads.metadata;
      let metadata = '';
      const storageType = createInputParam(mtdt, 'storage_type');
      const workingArea = stringify(payloads.metadata.working_area);
      const fleetEquipment = stringify(payloads.metadata.fleet_equipment);
      const document = stringify(payloads.metadata.document);
      const cdd = createInputParam(mtdt, 'cdd');
      const standby = createInputParam(mtdt, 'standby');
      metadata = `metadata: {
        ${storageType}
        ${cdd}
        ${standby}
        working_area: ${workingArea}
        fleet_equipment: ${fleetEquipment}
        document: ${document}
      }`;

      if (!isEmpty(cont)) {
        const type = createInputParam(cont, 'type', false);
        const width = createInputParam(cont, 'width', false);
        const length = createInputParam(cont, 'length', false);
        const height = createInputParam(cont, 'height', false);
        container = `container: {
          ${type}
          ${width}
          ${length}
          ${height}
        }`;
      }

      const mutation = `mutation {
        vehicle: create_vehicle(input: {
          ${regNo}
          company_id: ${companyId}
          ${container}
          ${metadata}
        }) {
          id
          reg_no
          container {
            type
            length
            width
            height
          }
          driver {
            id
            name
          }
          company {
            id
            name
            type
          }
          metadata
          created_at
        }
      }`;

      return api(mutation, 'create_vehicle').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.vehicle);
        return data.vehicle;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
      });
    },
    DELETE_DATA({ state, commit, rootState }, vehicleId) {
      const id = !vehicleId ? state.detailDataId : vehicleId;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        deleted: delete_vehicle(id: ${id})
      }`;

      return api(mutation, 'delete_vehicle').then(({ data }) => {
        const deleteOk = data.deleted;
        if (deleteOk) commit('DELETE_DETAIL_DATA', id);
        return deleteOk;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    LOAD_VEHICLE_STATUS({ commit, rootState }, locationIds) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `{
        vehicle_shipment_status(location_ids: [${locationIds}]) {
          available {
            count
            vehicles {
              reg_no
            }
          }
          assigned {
            count
            vehicles {
              reg_no
            }
          }
          on_duty {
            count
            vehicles {
              reg_no
            }
          }
        }
      }`;

      return api(query, 'vehicle_status').then(({ data }) => {
        const { vehicle_shipment_status } = data;
        return vehicle_shipment_status;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DATA');
      });
    },
    LOAD_VEHICLE_DRIVER({ commit, rootState }, payloads) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `{
        vehicle_driver(vehicle_id: ${payloads.vehicle_id}) {
          id
        }
      }`;

      return api(query, 'vehicle_driver').then(({ data }) => {
        const { vehicle_driver } = data;
        commit('SET_VEHICLE_DRIVER', vehicle_driver);
        return vehicle_driver;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_VEHICLE_DRIVER');
      });
    },
    LOAD_VEHICLE_DRIVER2({ commit, rootState }, payloads) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `{
        vehicle_driver(employee_id: ${payloads.employee_id}) {
          id
        }
      }`;

      return api(query, 'vehicle_driver').then(({ data }) => {
        const { vehicle_driver } = data;
        commit('SET_VEHICLE_DRIVER2', vehicle_driver);
        return vehicle_driver;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_VEHICLE_DRIVER');
      });
    },
    CREATE_VEHICLE_DRIVER({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        vehicle: create_vehicle_driver(input: {
          vehicle_id: ${payloads.vehicle_id},
          employee_id: ${payloads.employee_id}
        }) {
          id
        }
      }`;

      return api(mutation, 'create_vehicle_driver').then(({ data }) => {
        const { vehicle_driver } = data;
        return vehicle_driver;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_VEHICLE_DRIVER');
      });
    },
    UPDATE_VEHICLE_DRIVER({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const employeeId = createInputParam(payloads, 'employee_id');
      const vehicleId = createInputParam(payloads, 'vehicle_id');

      const mutation = `mutation {
        vehicle: update_vehicle_driver(id: ${payloads.id}, input: {
          ${employeeId}
          ${vehicleId}
        }) {
          id
        }
      }`;

      return api(mutation, 'update_vehicle_driver').then(({ data }) => {
        const { vehicle_driver } = data;
        return vehicle_driver;
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_VEHICLE_DRIVER');
      });
    },
    DELETE_VEHICLE_DRIVER({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutationDelete = `mutation {
        deleted: delete_vehicle_driver(id: ${payloads.id})
      }`;

      return api(mutationDelete, 'delete_vehicle_driver').then(({ data }) => {
        const deleteOk = data.deleted;
        return deleteOk;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    CREATE_VEHICLE_USER({ state, commit, rootState }, userId) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        vehicle: create_vehicle_user(
          vehicle_id: ${detailDataId},
          user_id: ${userId},
        ) {
          id
          reg_no
          container {
            type
            length
            width
            height
          }
          driver {
            id
            name
          }
          gps_devices {
            id
            number
            type
            gps_info {
              longitude
              latitude
            }
            metadata
            created_at
          }
          company {
            id
            name
            type
          }
          user {
            id
            username
            full_name
            email
            created_at
          }
          prestart_checklist {
            id
            question
          }
          metadata
          created_at
        }
      }`;

      return api(mutation, 'create_vehicle_user').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.vehicle);
        return data.vehicle;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_VEHICLE_USER');
      });
    },
    DELETE_VEHICLE_USER({ state, rootState, commit }) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        deleted: delete_vehicle_user(id: ${detailDataId})
      }`;

      return api(mutation, 'delete_vehicle_user').then(({ data }) => {
        const { deleted } = data;
        return deleted;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_VEHICLE_USER');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/vehicles.js